export const AUTHORIZERED = 'AUTHORIZERED';
export const UNATHOURIZED = 'UNATHOURIZED';
